import React, { useState } from "react";
import {
  Card,
  Row,
  Col,
  Form,
  Button,
  Badge,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faBuilding,
  faLayerGroup,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import "./plans.css";

const AssignPlan = () => {
  const navigate = useNavigate();

  // Dummy Data (Later API se aayega)
  const companies = [
    { id: "1", name: "Infosys" },
    { id: "2", name: "TCS" },
    { id: "3", name: "Wipro" },
  ];

  const plans = [
    { id: "1", name: "Basic Plan", price: 0 },
    { id: "2", name: "Pro Plan", price: 999 },
    { id: "3", name: "Enterprise Plan", price: 4999 },
  ];

  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedPlan, setSelectedPlan] = useState("");

  return (
    <div className="plans-page">
      <Card className="shadow-sm border-0 plans-card">
        <Card.Body>

          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h4 className="fw-bold mb-1">Assign Plan to Company</h4>
              <small className="text-muted">
                Link a subscription plan with a company
              </small>
            </div>

            <Button variant="light" onClick={() => navigate(-1)}>
              <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
              Back
            </Button>
          </div>

          {/* Assignment Card */}
          <Card className="modal-section-card">
            <Card.Body>

              <Row className="mb-4">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      <FontAwesomeIcon icon={faBuilding} className="me-2" />
                      Select Company
                    </Form.Label>
                    <Form.Select
                      value={selectedCompany}
                      onChange={(e) => setSelectedCompany(e.target.value)}
                    >
                      <option value="">Choose company</option>
                      {companies.map((company) => (
                        <option key={company.id} value={company.id}>
                          {company.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      <FontAwesomeIcon icon={faLayerGroup} className="me-2" />
                      Select Plan
  681b78a9cf2b8c097114e7c6                  </Form.Label>
                    <Form.Select
                      value={selectedPlan}
                      onChange={(e) => setSelectedPlan(e.target.value)}
                    >
                      <option value="">Choose plan</option>
                      {plans.map((plan) => (
                        <option key={plan.id} value={plan.id}>
                          {plan.name} (
                          {plan.price === 0
                            ? "Free"
                            : `₹${plan.price}`})
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              {/* Preview */}
              {selectedCompany && selectedPlan && (
                <div className="assignment-preview p-3 mb-3">
                  <Badge className="plan-chip me-2">
                    Company Selected
                  </Badge>
                  <Badge className="plan-chip">
                    Plan Selected
                  </Badge>
                </div>
              )}

              <div className="text-end">
                <Button className="save-plan-btn">
                  <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                  Assign Plan
                </Button>
              </div>

            </Card.Body>
          </Card>

        </Card.Body>
      </Card>
    </div>
  );
};

export default AssignPlan;